import { createActionCreator, paramsEncode } from '../../../utils/';
import request from '../../../utils/request';
import constant from './constant';
import Urls from '../../../../config/index';

export const createLoadingAction = createActionCreator(constant.loading, loading => loading);
export const createSearchAction = createActionCreator(constant.search, o => o);
export const createExecInfosAction = createActionCreator(constant.execInfos, o => o);
export const createExportUrlAction = createActionCreator(constant.url, o => o);

let execInfoUrl = Urls.TaskStatisticUrl.everydayExecInfo;
let importUrl = Urls.TaskStatisticUrl.importUrl;
let exportUrl = Urls.TaskStatisticUrl.exportEverydayExecTask;

//获取数据统计（表格数据）
export const getTaskInfos = () => {
    return async (dispatch, getState) => {
        try {
            dispatch(createLoadingAction(true));
            let response = await request(execInfoUrl);
            dispatch(createExecInfosAction(response));
        } catch (e) {
            throw new Error(e);
        } finally {
            dispatch(createLoadingAction(false));
        }
    }
}

//获取数据统计（表格数据）
export const importDol = () => {
    return async (dispatch, getState) => {
        try {
            dispatch(createLoadingAction(true));
            let response = await request(importUrl);
        } catch (e) {
            throw new Error(e);
        } finally {
            dispatch(createLoadingAction(false));
        }
    }
}

//下载地址
export const getExportUrl = (search) => {
    return (dispatch, getState) => {
        let search = getState().everydayExecInfo.search;
        let url = exportUrl + paramsEncode(Object.assign({}, search,{time:{}}));
          console.log(url)
        dispatch(createExportUrlAction(url));
    }
}

// 
export const handleSearch = (search) => {
    return (dispatch, getState) => {
        dispatch(createSearchAction(search));
    }
}




// WEBPACK FOOTER //
// ./pages/StatisticalAnalysis/everydayExecInfo/action.js